import { render, staticRenderFns } from "./EventTabsNavigation.vue?vue&type=template&id=848a3086&scoped=true&"
import script from "./EventTabsNavigation.vue?vue&type=script&lang=js&"
export * from "./EventTabsNavigation.vue?vue&type=script&lang=js&"
import style0 from "./EventTabsNavigation.vue?vue&type=style&index=0&id=848a3086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848a3086",
  null
  
)

export default component.exports